import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { AuthService } from '@shared/auth';
import { PulseBaseComponent, BaseConfig } from '@shared/layout/base';
import { HeaderConfig } from '@shared/layout/header';
import { NavigationConfig } from '@shared/layout/navigation';

import { Location } from '@shared/models';

import { ENVIRONMENT_CONFIG } from '@shared/config';
import { WalmartEnvironmentConfig } from '@walmart/config';
@Component({
  selector: 'walmart-master',
  imports: [PulseBaseComponent],
  templateUrl: './walmart-master.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WalmartMasterComponent {
  private envConfig = inject<WalmartEnvironmentConfig>(ENVIRONMENT_CONFIG);
  private authService = inject(AuthService);
  private siteMaintenanceUrl = `${this.envConfig.apiUrl}/v1/SiteMaintenance`;

  protected readonly baseConfig: BaseConfig = {
    toastDuration: 7000,
    toastPosition: 'top-center'
  };

  protected readonly navigationConfig: NavigationConfig = {
    logoExapandedUrl: '/assets/imgs/lumatrak_pulse_no_circle.png',
    logoCollapsedUrl: '/assets/imgs/lumatrak_circle_white.png',
    logoAltText: 'LumaTrak Logo'
  };

  protected readonly headerConfig: HeaderConfig = {
    companyLogoUrl: '/assets/imgs/walmart.png',
    companyLogoAltText: 'Walmart Logo',
    taglineUrl: '/assets/imgs/work_better_tag.png',
    taglineAltText: 'Work Better Together'
  };

  protected readonly navMenu = computed(() => this.authService.user().menuItems ?? []);

  constructor() {
    // TODO:Bring this back before release
    // this.httpHelper.get<boolean>(`${this.siteMaintenanceUrl}/UsingProductionDatabase`).subscribe({
    //   next: (isProductionDatabase: boolean) => {
    //     this.layoutService.setErrorMessage(null);
    //     // Show an error message if the environment is inconsistent with the database type
    //     if (this.isTestingEnvironment() && isProductionDatabase) {
    //       this.layoutService.setErrorMessage($localize`You are currently using PRODUCTION data in a DEVELOPMENT environment!`);
    //     } else if (this.isProductionEnvironment() && !isProductionDatabase && this.isLumatrakUser()) {
    //       this.layoutService.setErrorMessage($localize`You are currently using DEVELOPMENT data in a PRODUCTION environment!`);
    //     }
    //   },
    //   error: (error) => {
    //     console.error($localize`Failed to load database type: ${error}`);
    //   }
    // });
  }

  isTestingEnvironment() {
    const location = window.location.hostname;
    return [Location.Localhost, Location.Preview].includes(location as Location);
  }

  isProductionEnvironment() {
    const location = window.location.hostname;
    return [Location.Pulse, Location.Beta].includes(location as Location);
  }
}
